import UploadExpenseIcon from '@images/expenses/upload-expense-modal-icon.svg?react'
import { PreviewFile } from '@views/expenseManagement/components'
import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'

const UploadContainer = ({ onRemoveAll, onFileUpload, file, removeFile, error }) => {
  return file ? (
    <PreviewFile removeFile={removeFile} file={file} />
  ) : (
    <div className={`document-container ${cn({ error: !!error })}`}>
      <div
        className='drag-and-drop-container-in-modal'
        onClick={() => {
          onRemoveAll()
          onFileUpload()
        }}
      >
        <div className='drag-and-drop-image-container'>
          <UploadExpenseIcon />
        </div>
        <div>
          {!window.matchMedia('(pointer: coarse)').matches
            ? tr('FRONTEND.EXPENSE_MODAL.DRAG_AND_DROP', 'Drag & drop receipt here or click to upload')
            : tr('FRONTEND.EXPENSES.EXPENSE_MODAL.CLICK_TO_UPLOAD', 'Click here to upload receipt')}

          <ErrorDisplay error={error} hideIcon />
        </div>
      </div>
    </div>
  )
}

export default UploadContainer
